import React from "react";
import ComponentCard from "./ComponentCard";
import ArticleCard from "./ArticleCard";
import BookCard from "./BookCard";
import TutorialCard from "./TutorialCard";

export default function ResourceCard(props) {
  const resource = props.resource;
  const onUpdate = props.onUpdate;

  if (resource.type === "component") {
    return <ComponentCard resource={resource} onUpdate={onUpdate} />;
  }

  if (resource.type === "book") {
    return <BookCard resource={resource} onUpdate={onUpdate} />;
  }

  if (resource.type === "tutorial") {
    return <TutorialCard resource={resource} onUpdate={onUpdate} />;
  }

  return <ArticleCard resource={resource} onUpdate={onUpdate} />;
}
